(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chikara-vendor-catalog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chikara-vendor-catalog')) {
  customElements.define('chikara-vendor-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.initialize(), {once:true});
      else this.initialize();
    }
    async initialize() {
      this.grid = this.querySelector('[data-catalog-grid]');
      if (!this.grid) return;
      const total = Number(this.dataset.total);
      const sourcePages = Math.max(1, Number(this.dataset.pages));
      const ownPage = Number(this.dataset.sourcePage);
      this.setAttribute('aria-busy', 'true');
      try {
        if (total > 25000) throw new Error('Catalog exceeds native pagination depth');
        const byPage = new Map([[ownPage, Array.from(this.grid.querySelectorAll('[data-catalog-product]'))]]);
        const pending = Array.from({length:sourcePages}, (_, i) => i + 1).filter(page => page !== ownPage);
        const worker = async () => {
          while (pending.length) {
            const page = pending.shift();
            const url = new URL(location.href);
            url.searchParams.delete('ck_page');
            url.searchParams.delete('ck_size');
            url.searchParams.set('section_id', this.dataset.section);
            url.searchParams.set('page', String(page));
            const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(20000)});
            if (!response.ok) throw new Error('Catalog page unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const catalog = doc.querySelector('chikara-vendor-catalog');
            if (!catalog || catalog.dataset.theme !== this.dataset.theme || catalog.dataset.vendor !== this.dataset.vendor || Number(catalog.dataset.total) !== total || Number(catalog.dataset.sourcePage) !== page) throw new Error('Catalog response changed');
            byPage.set(page, Array.from(catalog.querySelectorAll('[data-catalog-product]')));
          }
        };
        await Promise.all(Array.from({length:Math.min(3,pending.length)}, worker));
        const cards = Array.from(byPage.entries()).sort((a,b)=>a[0]-b[0]).flatMap(entry=>entry[1]);
        const ids = new Set(cards.map(card=>card.dataset.catalogProduct));
        if (cards.length !== total || ids.size !== total) throw new Error('Catalog count mismatch');
        this.cards = cards.sort((a,b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true') || Number(a.dataset.sourceOrder) - Number(b.dataset.sourceOrder));
        for (const card of this.cards) {
          for (const img of card.querySelectorAll('img[data-mainimage]')) {
            if (!img.getAttribute('src')) img.setAttribute('src', img.dataset.mainimage.replace('respimgsize', '600x600'));
            img.loading = 'lazy';
            img.decoding = 'async';
          }
        }
        this.grid.replaceChildren(...this.cards);
        this.querySelector('[data-native-pages]').hidden = true;
        this.querySelector('[data-controls]').hidden = false;
        this.querySelector('[data-client-pages]').hidden = false;
        this.querySelector('[data-catalog-status]').textContent = this.dataset.ready.replace('__count__', String(total));
        this.dataset.complete = String(total);
        this.querySelector('[data-sort]').addEventListener('change', event => {
          const url = new URL(location.href);
          url.searchParams.set('sort_by',event.target.value);
          url.searchParams.delete('page');
          url.searchParams.delete('ck_page');
          location.assign(url);
        });
        this.querySelector('[data-size]').addEventListener('change', event=>this.navigate(1,event.target.value));
        this.querySelector('[data-previous]').addEventListener('click',()=>this.navigate(this.page-1,this.sizeValue));
        this.querySelector('[data-next]').addEventListener('click',()=>this.navigate(this.page+1,this.sizeValue));
        window.addEventListener('popstate',()=>this.renderPage());
        this.renderPage();
      } catch (error) {
        this.querySelector('[data-catalog-status]').textContent = this.dataset.error;
        this.dataset.catalogError = 'true';
      } finally {
        this.setAttribute('aria-busy','false');
      }
    }
    renderPage() {
      const params = new URL(location.href).searchParams;
      const requestedSize = params.get('ck_size') || this.dataset.defaultSize || '12';
      this.sizeValue = ['12','16','32','all'].includes(requestedSize) ? requestedSize : '12';
      const size = this.sizeValue === 'all' ? Math.max(1,this.cards.length) : Number(this.sizeValue);
      const pages = Math.max(1,Math.ceil(this.cards.length/size));
      this.page = Math.min(pages,Math.max(1,Number(params.get('ck_page') || params.get('page')) || 1));
      this.cards.forEach((card,index)=>card.hidden = index < (this.page-1)*size || index >= this.page*size);
      this.querySelector('[data-size]').value = this.sizeValue;
      this.querySelector('[data-current-page]').textContent = this.dataset.pageLabel.replace('__current__',String(this.page)).replace('__total__',String(pages));
      this.querySelector('[data-previous]').disabled = this.page === 1;
      this.querySelector('[data-next]').disabled = this.page === pages;
      this.dataset.visiblePage = String(this.page);
    }
    navigate(page,size) {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.set('ck_page',String(page));
      url.searchParams.set('ck_size',size);
      history.pushState({},'',url);
      this.renderPage();
      this.scrollIntoView({block:'start',behavior:'auto'});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
